import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-brand-dark text-white pt-16 pb-8" data-id="element-837">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-838">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-839">
          <div className="col-span-1 md:col-span-1" data-id="element-840">
            <img className="h-24 w-auto mb-6" src="https://cdn.magicpatterns.com/uploads/jbELFVU6yimTHPdBB4r5GJ/175975597_padded_logo.png" alt="Precision Pro Sprayers" data-id="element-841" />
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-842">
              Professional grade electric sprayers built for contractors who
              need reliability and speed.
            </p>
          </div>

          <div data-id="element-843">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-844">
              Products
            </h3>
            <ul className="space-y-3" data-id="element-845">
              <li data-id="element-846">
                <Link to="/products/forcex-complete" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-847">
                  ForceX Complete Kit
                </Link>
              </li>
              <li data-id="element-848">
                <Link to="/products/forcex-diy" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-849">
                  ForceX DIY Kit
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-850">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-851">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-852">
              <li data-id="element-853">
                <Link to="/about" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-854">
                  About Us
                </Link>
              </li>
              <li data-id="element-855">
                <Link to="/warranty" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-856">
                  Warranty & Returns
                </Link>
              </li>
              <li data-id="element-857">
                <Link to="/contact" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-858">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-859">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-860">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-861">
              <li className="flex items-start" data-id="element-862">
                <Phone className="h-5 w-5 text-brand-yellow mr-3 mt-0.5" data-id="element-863" />
                <span className="text-gray-300" data-id="element-864">810-818-5941</span>
              </li>
              <li className="flex items-start" data-id="element-865">
                <Mail className="h-5 w-5 text-brand-yellow mr-3 mt-0.5" data-id="element-866" />
                <span className="text-gray-300" data-id="element-867">
                  brandon@precisionprosprayers.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-868">
          <p className="text-gray-500 text-sm" data-id="element-869">
            © {new Date().getFullYear()} Precision Pro Sprayers. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-870">
            <Link to="/warranty" className="text-gray-500 text-sm hover:text-brand-yellow" data-id="element-871">
              Privacy Policy
            </Link>
            <Link to="/warranty" className="text-gray-500 text-sm hover:text-brand-yellow" data-id="element-872">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}